import { render, staticRenderFns } from "./AcceptedStatus.vue?vue&type=template&id=b6681fd4"
import script from "./AcceptedStatus.vue?vue&type=script&lang=js"
export * from "./AcceptedStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports